<template>
  <div id="menu-bar">
    <CompanyLogo />
    <el-menu :router=true :default-active="route.path.replaceAll('%20', ' ')">

      <!--      AQA      -->
      <el-sub-menu index="1">
        <template #title>
          <el-icon><Van /></el-icon>
          <span>AQA</span>
        </template>

        <el-menu-item index="/dashboard">
          <template #title>
            <el-icon>
              <Odometer/>
            </el-icon>
            <span>Dashboard</span>
          </template>
        </el-menu-item>

        <el-sub-menu index="2">
          <template #title>
            <el-icon><Collection /></el-icon>
            <span>Projects</span>
          </template>
          <el-menu-item v-for="project in projects" :key="project.name" :index="'/project/' + project.name">
            <span>{{ project.name }}</span>
          </el-menu-item>
        </el-sub-menu>

        <el-menu-item index="/timeline">
          <template #title>
            <el-icon>
              <Calendar />
            </el-icon>
            <span>Roadmap</span>
          </template>
        </el-menu-item>
      </el-sub-menu>


      <!--      QA      -->
      <el-sub-menu index="3">
        <template #title>
          <el-icon><Management /></el-icon>
          <span>QA</span>
        </template>

        <el-menu-item index="/qa-docs">
          <span>Documents</span>
        </el-menu-item>
      </el-sub-menu>

      <!--      Wiki      -->
      <el-sub-menu index="4">
        <template #title>
          <el-icon><DocumentCopy /></el-icon>
          <span>Wiki</span>
        </template>

        <el-menu-item index="/create-wiki">
          <template #title>
            <el-icon>
              <Plus/>
            </el-icon>
            <span>Create doc</span>
          </template>
        </el-menu-item>

        <el-menu-item v-for="doc in store.wikiDocuments" :key="doc.name" :index="'/wiki/' + doc.name">
          <template #title>
            <el-icon>
              <Document />
            </el-icon>
            <span>{{ doc.name }}</span>

          </template>
        </el-menu-item>
      </el-sub-menu>

<!--      <el-menu-item>-->
<!--        <el-icon><Tools /></el-icon>-->
<!--        <span>Administration</span>-->
<!--      </el-menu-item>-->


    </el-menu>
  </div>
</template>

<script setup lang="ts">
import type { AxiosResponse } from "axios";
import { useRoute } from 'vue-router';
import { onMounted } from "vue";

import store from '@/stores/store';
import CompanyLogo from './icons/CompanyLogo.vue';
import { invokeGet } from "@/services/api-client";


const route = useRoute()

const projects = store.projects

onMounted(async () => {
  const wikis = await invokeGet('Wiki pages', 'wiki') as AxiosResponse
  store.wikiDocuments = wikis.data
})

</script>

<style scoped>
#menu-bar {
  padding-top: 15px;
}

.el-menu {
  border: none;
  --el-menu-bg-color: linear-gradient(to left, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 1));
}

.el-menu-vertical {
  background: linear-gradient(to left, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 1));
  border-color: var(--main-text-color);

  span {
    font-size: 16px;
  }
}

.el-menu-item {
  font-weight: bold;

  --el-menu-hover-bg-color: var(--hover-background-color);
  --el-menu-active-color: #409eff;
}

:deep(.el-menu-item.is-active) {
  color: white;
  background-color: var(--hover-background-color);
}

:deep(.el-sub-menu__title) {
  font-weight: bold;
  --el-menu-hover-bg-color: var(--hover-background-color);
}
</style>